let routes = [{
    name: 'Students',
    icon: 'group',
    header: true,
    service:true,
    permission: 'student-read|student-create|student-promote',
    children: [
        {
            name: 'Search',
            path: '/search-students',
            icon: 'search',
            permission: 'student-read'
        },
        {
            name: 'Admit',
            path: '/admit',
            icon: 'person_add',
            permission: 'student-create'
        },
        {
            name: 'Promote',
            path: '/promote',
            icon: 'plus_one',
            permission: 'student-promote'
        },
        {
            name: 'Left',
            path: '/search-students?list_type=LEFT',
            icon: 'delete',
            permission: 'student-promote'
        },
        {
            name: 'Data Entry Setting',
            path: '/data-entry-setting',
            icon: 'settings',
            permission: 'student-create'
        },
        {
            name: 'Bulk Admit',
            path: '/bulk-admission',
            icon: 'person_add',
            permission: 'student-create'
        },
        {
            name: 'Bulk Device Sync',
            path: '/student-bulk-ref',
            icon: 'sync',
            permission: 'student-create'
        },

        
    ]
}];

export default routes;